import { useDispatch, useSelector } from "react-redux";
import { Appstore } from "../../redux";
import { useEffect, useState } from "react";
import { SetRegions } from "../../redux/catalogs/states";
import { getRegions } from "../../Services/Region";
import { IRegion } from "../../interfaces/models/IRegion";

let sharedRegionsRequest: Promise<IRegion[]> | null = null;

async function fetchRegionsShared (): Promise<IRegion[]> {
  if (!sharedRegionsRequest) {
    sharedRegionsRequest = getRegions()
      .then((data) => {
        const regions = Array.isArray(data) ? data : [];
        if (regions.length === 0) {
          sharedRegionsRequest = null;
        }
        return regions;
      })
      .catch((error) => {
        sharedRegionsRequest = null;
        throw error;
      });
  }
  return sharedRegionsRequest;
}

export const UseRegionList = () => {
  const [isFetching, setIsFetching] = useState(false);

  const dispatch = useDispatch();
  const regionData = useSelector((state: Appstore) => state.regions);

  useEffect(() => {
    if (regionData.length > 0) {
      setIsFetching(false);
      return;
    }

    let cancelled = false;
    setIsFetching(true);

    fetchRegionsShared()
      .then((response) => {
        if (!cancelled) {
          dispatch(SetRegions(response));
          if (!response.length) {
            console.error('No regions found. Please check the data source.');
          }
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        if (!cancelled) {
          setIsFetching(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [regionData.length, dispatch]);

  return { regionData, isFetching };
};
